import type { JSX } from 'react';
import { FormSubsection } from '@ksyos/design-system';
import type { ProcessActivityReadSubsection } from '@common/interfaces/processActivityReadSection';
import type { ComponentsMap } from './readForm.types';
import { ReadFormSectionItem } from './ReadFormSectionItem';

type ReadFormSubsectionProps = Readonly<{
    components?: ComponentsMap;
    subsection: ProcessActivityReadSubsection;
}>;

export function ReadFormSubsection({ components, subsection }: ReadFormSubsectionProps): JSX.Element {
    const items = subsection.items.map((item) => (
        <ReadFormSectionItem
            components={components}
            item={item}
            key={item.key}
        />
    ));

    return <FormSubsection title={subsection.title}>{items}</FormSubsection>;
}
